import React, { useEffect, useState, FC } from "react";
import "./AccessoryUpdateCartDotloader.css";
import { SBCONSTANT } from "../../../utils/constants";
import { getLocalStorageWithExpiry } from "../../../utils/utils";
import { MultiItemAccessoriesSchema } from "../MultiItemAccessories/MultiItemAccessoriesSchema";

interface DotLoaderSchema {
  content: MultiItemAccessoriesSchema;
  keyParams?: string;
}
const AccessoryUpdateCartDotloader: FC<DotLoaderSchema> = ({ content, keyParams }) => {
  const [index, setIndex] = useState<number>(0);
  const [constKeys, setConstKeys] = useState<Record<string, string>>({});
  const loaderValues: any = {
    checkout: [
      content?.updatingCartBundling
    ],
    loading: [constKeys?.loading],
  };
  const contentArray = keyParams
    ? loaderValues[`${keyParams}`]
    : loaderValues["checkout"];

  useEffect(() => {
    setConstKeys(getLocalStorageWithExpiry(SBCONSTANT));
  }, []);

  useEffect(() => {
    let i = contentArray.length - 1;
    setIndex(i);
    const timerInterval = setInterval(() => {
      setIndex(i--);
      if (i < 0) {
        i = contentArray.length - 1;
      }
    }, 2000);
    return () => {
      clearTimeout(timerInterval);
    };
  }, []);
  return (
    <div
      className={`d-flex align-items-center justify-content-center linetable-dotLoader-loaderParent`}
    >
      <div className="linetable-dotLoader-dotClass">
        <div className="linetable-dotLoader-dots"></div>
        <div className="linetable-dotLoader-dots"></div>
        <div className="linetable-dotLoader-dots"></div>
        <div className="linetable-dotLoader-dots"></div>
      </div>
      <div>
        <h4 className="linetable-dotLoader-dotContent">{contentArray[index]} </h4>
      </div>
    </div>
  );
};
export default AccessoryUpdateCartDotloader;
